import React from "react";
import "./VideoSkeletonCard.css";

const VideoSkeletonCard = () => {
  return (
    <div className="video-skeleton-card">
      <div className="video-skeleton-card__header">
        <div className="video-skeleton-card__avatar" />
        <div className="video-skeleton-card__meta">
          <div className="video-skeleton-card__line video-skeleton-card__line--short" />
          <div className="video-skeleton-card__line video-skeleton-card__line--xs" />
        </div>
      </div>

      <div className="video-skeleton-card__media">
        <div className="video-skeleton-card__shimmer" />
      </div>

      <div className="video-skeleton-card__body">
        <div className="video-skeleton-card__line video-skeleton-card__line--medium" />
      </div>
    </div>
  );
};

export default VideoSkeletonCard;
